import { exportReport, type ExportFormat } from '../api/reports'
import { sanitize } from './describe'
import type { Definition, Locale, Words } from './types'

/**
 * DESCARCAREA RAPORTULUI INTREG, fara nimic nou pe server:
 *
 *  - PDF: pagina de tiparire a browserului, cu raportul intreg (titlu, data,
 *    compania, fiecare bloc desenat) - foaia de `@media print` din saved.css
 *    ascunde restul ecranului cat dureaza tiparirea;
 *  - Excel / CSV: cate un fisier pe bloc, prin descarcarea care exista deja
 *    pentru o definitie, unul dupa altul (browserul nu primeste zece cereri
 *    deodata).
 */

export interface DownloadBlock {
  title: Words
  definition: Definition
}

export async function downloadBlocks(
  company: number,
  blocks: DownloadBlock[],
  format: Exclude<ExportFormat, 'pdf'>,
  locale: Locale,
  onProgress: (done: number, total: number) => void = () => {}
): Promise<void> {
  for (let i = 0; i < blocks.length; i++) {
    onProgress(i, blocks.length)
    const b = blocks[i]!
    await exportReport(company, { ...sanitize(b.definition), title: b.title[locale] }, format, locale)
  }
  onProgress(blocks.length, blocks.length)
}

const PRINT_CLASS = 'od-rep-printing'

/** Tipareste numai raportul; clasa de pe body se scoate dupa tiparire. */
export function printReport(title: string): void {
  const before = document.title
  document.body.classList.add(PRINT_CLASS)
  if (title) document.title = title
  const done = () => {
    document.body.classList.remove(PRINT_CLASS)
    document.title = before
    window.removeEventListener('afterprint', done)
  }
  window.addEventListener('afterprint', done)
  try {
    window.print()
  } finally {
    /* Unele browsere nu trimit `afterprint`; `print()` e oricum sincron acolo. */
    window.setTimeout(done, 1000)
  }
}
